module.exports = require("./interopRequireDefault.js");


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/helpers/interop-require-default.js
// module id = 116
// module chunks = 13